import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
const AboutUs = () => {
  let path = window.location.pathname;
  return (
    <>
      <SEO
        title="About Us"
        description="Learn about Indorinama - Premier advertising and digital services company founded in 2019, based in Indore, Madhya Pradesh. Discover our vision to be the best advertising agency."
        keywords="about us, advertising agency, digital marketing, Indore, Madhya Pradesh, Indorinama, advertising company"
        url="https://indorinama.com/about"
      />
      <div className="homepage">
        <Navbar />
        {path === "/about" && (
          <div
            className="terms-conditions col-lg-10 card mx-auto border rounded my-4 p-4"
            style={{
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(1px)",
            }}
          >
            <h2 className="card-title text-center mb-4">About Us</h2>
            <p className="card-text text-muted">
              <strong>Indorinama</strong>, founded in <strong>2019</strong>, has
              swiftly become a prestigious Advertising & Digital Services
              Company headquartered in <strong>Indore, Madhya Pradesh</strong>.
              Renowned for its excellence in the industry, Indorinama serves as
              your trusted partner in advertising and digital marketing
              endeavors. Our philosophy revolves around crafting and nurturing
              perfect advertisement and digital marketing journeys for our
              clients.
            </p>
            <p className="card-text text-muted">
              Comprising a team of adept individuals, we at Indorinama are
              committed to continuous collaboration and innovation. We believe
              in inspiring one another, fostering growth collectively, and
              consistently striving to discover the most effective advertising
              solutions tailored to meet your diverse and unique requirements.
            </p>
            <p className="card-text text-muted">
              At Indorinama, we perceive ourselves as explorers, constantly
              seeking to expand our knowledge and expertise. We stay abreast of
              the latest developments shaping the digital landscape, eager to
              adapt and integrate these advancements into our strategies. Our
              aim is to remain at the forefront of the industry, ensuring that
              our clients receive cutting-edge solutions that drive results.
            </p>
            <div className="card bg-light mb-3">
              <div className="card-body">
                <h5 className="card-title">Our Vision</h5>
                <p className="card-text text-muted">
                  Our vision is simply to be the best Advertising Agency by
                  using our insights, experience, expertise, creativity,
                  environment knowledge and business sense to increase our
                  clients' profits in a sustainable way. Together let’s Explore,
                  Challenge, Transform and Deliver.
                </p>
              </div>
            </div>
            <div className="card bg-light">
              <div className="card-body">
                <h5 className="card-title">Our Mission</h5>
                <p className="card-text text-muted">
                  To make a meaningful difference to the brands, the businesses
                  and the lives of the people we work with.
                </p>
              </div>
            </div>
          </div>
        )}
        {path === "/t&c" && (
          <div
            className="col-lg-10 card mx-auto border rounded my-4 p-4"
            style={{
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(1px)",
            }}
          >
            <div className="terms-conditions">
              <h2 className="text-center mb-4">Terms & Conditions</h2>
              <p>
                We appreciate the trust you place in us when you visit our site
                www.Indorinama.com. This privacy policy governs the manner in
                which Indorinama collects, uses, maintains and discloses
                information collected from users of the website. This privacy
                policy applies to the site and all products and services offered
                by Indorinama.
              </p>
              <p>
                By using this site, you signify your acceptance of this policy
                and terms of service.
              </p>
              <h4>Personal identification information</h4>
              <p>
                We may collect personal identification information from users in
                a variety of ways, including, but not limited to, when users
                visit our site, register on the site and in connection with
                other activities, services, features or resources we make
                available on our site. Users may be asked for, as appropriate,
                name, email address, mailing address, phone number. We will
                collect personal identification information from users only if
                they voluntarily submit such information to us. Users can always
                refuse to supply personally identification information, except
                that it may prevent them from engaging in certain site related
                activities.
              </p>
              <h4> Web browser cookies </h4>
              <p>
                Our site may use “cookies” to enhance user experience. User’s
                web browser places cookies on their hard drive for
                record-keeping purposes and sometimes to track information about
                them. User may choose to set their web browser to refuse
                cookies, or to alert you when cookies are being sent. If they do
                so, note that some parts of the site may not function properly.
                "
              </p>

              <h4>Use of collected information </h4>
              <p>
                "Indorinama collects and uses personal information for the
                following purposes:
              </p>
              <p>
                To improve customer service Your information helps us to more
                effectively respond to your customer service requests and
                support needs. To personalize user experience We may use
                information in the aggregate to understand how our users as a
                group use the services and resources provided on our site. To
                send periodic emails Use of Google Analytics & In-page Analytics
                We may use Google Analytics, chat applets & in-page analytics
                tools to get data that helps us with various data points that
                help us take business decisions. This data is not personally
                identifiable since we don't ask users to give us any of their
                personal data on our site and the kind of data we get is
                aggregate and not individual. The data collected gives us an
                understanding of how many people visited our site, how many of
                them were unique, the number of page views, time spent, location
                of the users, the pages they viewed, the browser used, the
                browsing behaviour etc. "
              </p>

              <h4>Taxes</h4>
              <p>
                " Member agrees to pay GST or other similar taxes, whether
                international, national, state, or local, however designated,
                which are levied or imposed or may be levied or imposed, with
                respect to this Agreement. Member is responsible and liable for
                any fees, including attorney and collection fees, that
                Indorinama may incur in its efforts to collect any remaining
                balances due from Member. This Section shall in no way limit any
                other remedies available to Indorinama at law or in equity.
                Member agrees to mention GST registration number and Entity
                Name, if applicable. The Member will ensure that the GST
                registration number and the Entity Name, if applicable
                corresponds to the billing address provided, as no change in the
                said details will be allowed once the order is placed. Member
                further acknowledges that Indorinama will not be responsible for
                verification of GST registration number and the Entity name, if
                applicable. Any tax liability arising consequent to
                non-compliance of law or due to furnishing of incorrect GST
                registration number and the Entity name, if applicable shall be
                borne by the Member. In the event, if Member fails to furnish
                GST registration number at the time of placing the order, the
                Member will be treated as ‘unregistered’ and will not be able to
                avail any input tax credit. In any case, the liability of
                Indorinama under GST regime would be limited to the amount of
                tax charged by Indorinama. "
              </p>

              <h4>Protection your information</h4>
              <p>
                " We adopt appropriate data collection, storage and processing
                practices and security measures to protect against unauthorized
                access, alteration, disclosure or destruction of your personal
                information, username, password, transaction information and
                data stored on our site. We do not spam our users with daily or
                weekly alerts. We only mail them when something worth their
                while is to be reported. We don't sell or share your personal
                contact details with anybody, for commercial or other purposes.
                Your data shared with Indorinama is confidential with us.
              </p>
              <h4>For Media Owners & Publishers</h4>
              <p>
                {" "}
                Our vision is to make it easy for advertisers to discover the
                advertising spaces available anywhere across the world where
                their target audiences are and likewise make it easy for
                publishers & media owners to find the right takers of their
                media. In that regard, we list various advertising spaces and
                media owners’ media details on our site. Most of these are
                official tie-ups. However we also list media owners’ media
                details based on the publicly available information on their
                site with the objective of helping them generate more sales from
                the sea of advertisers visiting our page. If you are a media
                owner, whose media has been listed and would like us to
                discontinue showing it on our site, please write in to
                help@indorinama.in and we'll take your listing off the site
                within 7 working days. We have noble intentions and would love
                to work with partners who understand and appreciate the value we
                are trying to drive to advertisers and media owners alike. "
              </p>

              <p>
                "If you have a belief that your IP right has been violated or
                information is misrepresented on Indorinama, please report it to
                help@indorinama.in. We would need 7 working days to address the
                issue. To help us solve the issue quickly, please include the
                following in your email: Identification or description of the
                copyrighted work/ trademark that has been infringed Data that is
                being wrongly represented Change(s) that you would want us to
                make A name & number to contact Newsletter Subscription By
                registering an account on Our Website, you are automatically
                subscribed to our newsletter. This subscription allows us to
                keep you informed about our latest news, products, offers, and
                other relevant updates. Should you wish to unsubscribe from
                receiving our newsletter at any time, you may do so by clicking
                on the ""Unsubscribe"" link located at the bottom of any of our
                newsletter emails. Upon clicking this link, you will be promptly
                removed from our mailing list, and you will no longer receive
                these communications from us.
              </p>
              <h4> Changes to this privacy policy</h4>
              <p>
                Indorinama has the discretion to update this privacy policy at
                any time. We encourage users to frequently check this page for
                any changes to stay informed about how we are helping to protect
                the personal information we collect. You acknowledge and agree
                that it is your responsibility to review this privacy policy
                periodically and become aware of modifications.
              </p>
              <p>
                {" "}
                If you have any questions about this privacy policy, the
                practices of this site, media published on the site or your
                dealings with this site, please contact us at help@indorinama.in
                "
              </p>
            </div>
          </div>
        )}
        <Footer />
      </div>
    </>
  );
};

export default AboutUs;
